import { useQuery } from 'hooks/useCustomQuery';
import getLocationByID from 'API/Location/getLocationByID';

const useGetLocation = (locationId, enabled = true) => {
    return useQuery({
        queryKey: ['Location', locationId],
        queryFn: async () => {
            const response = await getLocationByID(locationId);
            return response.data;
        },
        enabled: enabled && !!locationId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetLocation;
